<template>
  <section class="content">
    <div class="box">
      <div class="box-header with-border">
        <h3 class="box-title">{{'files_download' | translate}}</h3>
      </div>
      <div class="box-controls">
        <div class="row">
          <div class="col-xs-12">
            <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
          </div>
        </div>
      </div>
      <div class="box-body">
        <h4>Hier finden Sie alle hilfreichen Dateien rund um <a href="http://www.schuhe.de" target="_blank">schuhe.de</a> zum herunterladen.</h4>
        <hr>
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th class="is-clickable" @click="getState('created_at', filters.created_at)">
                  <i :class="[filters.created_at === '' ? 'fa fa-sort' : `fa fa-sort-${filters.created_at}`, 'mr-5']"></i>
                  {{'date' | translate}}
                </th>
                <th class="is-clickable" @click="getState('title', filters.title)">
                  <i :class="[filters.title === '' ? 'fa fa-sort' : `fa fa-sort-${filters.title}`, 'mr-5']"></i>
                  {{'documents_name' | translate}}
                </th>
                <th class="is-clickable" @click="getState('sub_title', filters.sub_title)">
                  <i :class="[filters.sub_title === '' ? 'fa fa-sort' : `fa fa-sort-${filters.sub_title}`, 'mr-5']"></i>
                  {{'documents_describtion' | translate}}
                <th class="text-right">Download</th>
              </tr>
            </thead>
            <tbody>
            <tr v-for="file in pagination.data">
              <td><strong>{{file.created | orderDate}}</strong><br><small class="text-muted">{{file.created | orderDate(true)}}</small></td>
              <td><strong>{{file.title}}</strong></td>
              <td><small>{{file.subtitle}}</small></td>
              <td class="text-right">
                <a :href="file.path" target="_blank" class="btn btn-success"><i class="fa fa-cloud-download mr-5"></i>Download</a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="box-footer">
        <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
      </div>
    </div>
  </section>
</template>
<script>

export default {
  data () {
    return {
      pagination: {
        total: 0,
        per_page: 25,
        current_page: 1,
        total_pages: 0,
        data: []
      },
      pointsLink: {},
      filters: {
        created_at: '',
        title: '',
        sub_title: '',
      },
    }
  },
  methods: {
    clear () {
      this.filters = {
        created_at: '',
        title: '',
        sub_title: '',
      }
    },
    getState (obj, state) {
      this.clear()

      if (state === '') {
        state = 'asc'
      } else if (state === 'asc') {
        state = 'desc'
      } else {
        state = ''
      }
      this.filters[obj] = state
      this.paginate('')
    },
    refresh () {
      API.get('/download/files')
        .then(response => {
          this.pagination = response.data
        })
    },
    loadFilters() {
      API.get('inventory/filters')
        .then(response => {
          this.multiselectSeasons = response.data.season
        })
        .catch(error => {
          this.$store.dispatch('checkError', error)
          this.loading = false
        })
    },
    paginate (value) {
      let url = 'download/files?'
      let fs = Object.keys(this.filters)
      fs.forEach(function(value) {
          if (this.filters[value] !== ''){
            url += `${value}=${this.filters[value]}`
          }
        },this
      )
      this.loadFilters()
      API.get(url)
          .then(response => {
            this.pagination = response.data
          })
          .catch(error => {
            this.$store.dispatch('checkError', error)
          })
    },
    isImage (file) {
      return file.type === 'png' || file.type === 'jpg' || file.type === 'jpeg' || file.type === 'bmp' || file.type === 'gif'
    },
    getData () {
      this.clear()
      this.loadFilters();
      this.loading = true
    },

  },
  mounted () {
    this.$nextTick(() => {
      this.refresh()
    })
  }
}
</script>
<style>
    select option.normal{
        margin:40px;
        color:#fff;
        text-shadow:0 1px 0 rgba(0,0,0,.4);
        background:#202227
    }
    .picker:not(.month-year-label) {
        background: #212228;
    }
    .picker > .flexbox:not(.monthItem) {
        background-color: rgba(0,195,150,.075);
        border-color: #00C396;
        color: #00C396;
        font-weight: 600;
    }
    .picker > .flexbox.monthItem {
        background-color: #212228 ;
        color: white;
        font-weight: 600;
        border-top: 1px solid rgba(255,255,255, .15) !important;
    }
    .picker .monthItem .item:hover {
        background-color: #00C396 !important;
    }
    .date-popover{
        background: none !important;
        border: 1px solid rgba(255,255,255, .15) !important
    }
</style>
<style scoped>
    span.italic {
        font-style: italic;
        word-wrap: break-word;
    }
    hr {
        margin-top: 10px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/views/Downloads/Files.vue